/* unplugin-vue-components disabled */import script from "./PromotionsDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionsDetails.vue?vue&type=script&setup=true&lang=js"

import "./PromotionsDetails.vue?vue&type=style&index=0&id=3636e48a&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3636e48a"]])

export default __exports__